import { NgModule } from '@angular/core';
import { ToolbarModule } from 'primeng/toolbar';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { TabMenuModule } from 'primeng/tabmenu';
import { CardModule } from 'primeng/card';
import { CarouselModule } from 'primeng/carousel';
import { DividerModule } from 'primeng/divider';
import { TableModule } from 'primeng/table';
import { MenubarModule } from 'primeng/menubar';
import { DialogModule } from 'primeng/dialog';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { FileUploadModule } from 'primeng/fileupload';
import { PanelModule } from 'primeng/panel';
import { TreeModule } from 'primeng/tree';
import { GalleriaModule } from 'primeng/galleria';
import { SliderModule } from 'primeng/slider';
import { TagModule } from 'primeng/tag';
import { MenuModule } from 'primeng/menu';
import { DropdownModule } from 'primeng/dropdown';
import { EditorModule } from 'primeng/editor';
import { CalendarModule } from 'primeng/calendar';
import { RadioButtonModule } from 'primeng/radiobutton';
import { FieldsetModule } from 'primeng/fieldset';
import { ChipsModule } from 'primeng/chips';
import { InputSwitchModule } from 'primeng/inputswitch';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { CheckboxModule } from 'primeng/checkbox';
import { TooltipModule } from 'primeng/tooltip';

@NgModule({
  exports: [
    ToolbarModule,
    TooltipModule,
    InputTextModule,
    ButtonModule,
    TabMenuModule,
    CardModule,
    CarouselModule,
    DividerModule,
    TableModule,
    MenubarModule,
    DialogModule,
    ToastModule,
    ConfirmDialogModule,
    FileUploadModule,
    PanelModule,
    TreeModule,
    GalleriaModule,
    SliderModule,
    TagModule,
    MenuModule,
    DropdownModule,
    EditorModule,
    CalendarModule,
    RadioButtonModule,
    FieldsetModule,
    ChipsModule,
    InputSwitchModule,
    BreadcrumbModule,
    CheckboxModule
  ]
})
export class PrimengModule {}
